import { i18nextInit } from '@framework/i18n';
i18nextInit({
  lookupLocalStoragePrefix: 'fwpfo',
});
